<template>
  <div class="create-acivity activity-detail">
    <div class="acivity-left">
      <img src="../../assets/images/x.png" class="mobile-img">
      <img src="../../assets/images/liuhai.png" class="liuhai" alt="">
      <el-carousel class="scrol-image">
        <el-carousel-item v-for="item in imageArray" :key="item">
          <img :src="item" class="home-pic">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="acivity-right">
      <div style="width: 100%;height: 100%;">
        <div>
          <div class="tab-tit">
            <a @click="curId = 0" :class="{'cur':curId === 0}" style="border-radius: 5px 0 0 5px;">基础设置</a>
            <a @click="curId = 1" :class="{'cur':curId === 1}" style="border-left: none;border-right: none;border-radius: 0">活动配置</a>
            <a @click="curId = 2" :class="{'cur':curId === 2}" style="border-radius: 0 5px 5px 0">奖品设置</a>
          </div>
        </div>
        <div v-if="curId === 0">
          <el-form :inline="true" class="acivity-content-form" :model="formInline" label-width="80px">
            <el-form-item label="活动名称">
              <div class="activity-title">
                {{ formInline.name }}
              </div>
            </el-form-item>
            <el-form-item label="活动时间">
              <div class="activity-title">
                {{ formInline.start_time  }} 至 {{ formInline.end_time }}
              </div>
            </el-form-item>
            <el-form-item label="活动封面">
              <el-upload
                disabled
                class="avatar-uploader"
                name="file_upload"
                :action="uploadURL"
                :show-file-list="false">
                <img v-if="formInline.cover_img" :src="formInline.cover_img" class="avatar-pic">
                <img v-else src="../../assets/images/prize-start.png" class="avatar-pic">
              </el-upload>
            </el-form-item>
            <!--<p style="margin-left: 110px; margin-top: -35px;padding-left: 65px">格式为jpg、png、jpeg，图片大小不可大于1M。</p>-->
            <el-form-item label="活动说明" style="margin-top: 16px">
              <el-input
                disabled
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="formInline.description">
              </el-input>
            </el-form-item>
            <el-form-item label="样式风格">
              <div v-if="formInline.page_style === 1" class="wheel-style">扁平风格</div>
              <div v-if="formInline.page_style === 2" class="wheel-style">酷炫风格</div>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 1">
          <el-form :inline="true" class="acivity-setting-form" :model="formInline" label-width="110px">
            <el-form-item label="抽奖次数上限">
              <el-input disabled v-model="formInline.draw_num"></el-input>
            </el-form-item>
            <el-form-item label="每日抽奖上限">
              <el-input disabled v-model="formInline.everyday_draw_num"></el-input>
            </el-form-item>
            <el-form-item label="中奖个数上限">
              <el-input disabled v-model="formInline.lottery_num"></el-input>
            </el-form-item>
            <!-- <el-form-item label="标签">
              <div class="tags-look">
                <span class="tag-span-look" v-for="(item, index) in tagsArray" :key="index">
                  {{ item }}
                </span>
              </div>
            </el-form-item> -->
            <el-form-item label="参与设置">
              <div v-if="formInline.set_up === 2" class="wheel-style">仅会员参与</div>
              <div v-if="formInline.set_up === 3" class="wheel-style">提交表单</div>
              <div v-if="formInline.set_up === 1" class="wheel-style">不设置</div>
            </el-form-item>
            <el-form-item label="活动方式">
              <div v-if="formInline.receive_way === 1" class="wheel-style">线上活动</div>
              <div v-if="formInline.receive_way === 2" class="wheel-style">线下活动</div>
            </el-form-item>
            <el-form-item label="是否微信分享">
              <div v-if="formInline.wechat_share === 0" class="wheel-style">禁止分享</div>
              <div v-if="formInline.wechat_share === 1" class="wheel-style">允许分享</div>
            </el-form-item>
            <el-form-item label="奖品数量显示">
              <div v-if="formInline.show_num === 1" class="wheel-style">显示</div>
              <div v-if="formInline.show_num === 0" class="wheel-style">不显示</div>
            </el-form-item>
            <el-form-item label="关联公众号" class="public">
              <el-select disabled v-model="formInline.public_id" placeholder="请选择">
                <el-option
                  v-for="item in publicOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户来源" prop="source_id" class="public">
              <el-select disabled v-model="formInline.source_id" placeholder="请选择">
                <el-option
                  v-for="item in sources"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户来源说明" prop="source_content">
              <el-input
                disabled
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="formInline.source_content">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 2">
          <el-form :inline="true" class="acivity-prize-form" :model="formInline" label-width="200px">
            <div class="new-add-table">
              <el-table
                :data="formInline.prize"
                border
                style=""
                class="table">
                <el-table-column
                  prop=""
                  label="奖品等级"
                  width="110">
                  <template slot-scope="scope">
                    <span>{{level[scope.$index]}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品类型"
                  width="150">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prize_type === 1">实物</span>
                    <span v-if="scope.row.prize_type === 2">红包</span>
                    <span v-if="scope.row.prize_type === 3">优惠券</span>
                    <span v-if="scope.row.prize_type === 4">积分</span>
                    <!--<el-select disabled v-model="scope.row.prize_type" placeholder="请选择奖品类型">-->
                      <!--<el-option-->
                        <!--v-for="item in prizeOptions"-->
                        <!--:key="item.value"-->
                        <!--:label="item.label"-->
                        <!--:value="item.value">-->
                      <!--</el-option>-->
                    <!--</el-select>-->
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品名称/奖品数额"
                  width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.prize_type === 1 || scope.row.prize_type === 3">{{ scope.row.prize_name }}</span>
                    <span v-if="scope.row.prize_type === 2 || scope.row.prize_type === 4">{{ scope.row.prize_money }}</span>
                    <!--<el-input disabled v-if="scope.row.prize_type === 1 || scope.row.prize_type === 3" v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>-->
                    <!--<el-input-number disabled v-if="scope.row.prize_type === 2 || scope.row.prize_type === 4" class="prize-count" v-model="scope.row.prize_money" controls-position="right" :min="1"></el-input-number>-->
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品编号"
                  width="">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.prize_type === 1" v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                    <span v-else>无需填写</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="中奖概率"
                  width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.probability }}</span>%
                    <!--<el-input disabled v-model="scope.row.probability" class="prize-percent" placeholder=""></el-input>%-->
                  </template>
                </el-table-column>
                <el-table-column
                  prop="start"
                  label="奖品数量"
                  width="180">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prize_num }}</span>
                    <!--<el-input-number disabled v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1" :max="9999"></el-input-number>-->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getActivityDetails, modifyActivity, getWechatPublicListForNode, getCustomerSourceListForWepage } from '@/api/customer.js'

const cityOptions = ['扁平风格', '酷炫风格']
export default {
  name: 'add-activity',
  data() {
    return {
      tagsArray: [],
      curId: 0,
      date: [],
      tempArray: [require('../../assets/images/home-prize-0.png'), require('../../assets/images/home-prize-1.png'), require('../../assets/images/home-prize-2.png'), require('../../assets/images/home-prize-3.png'), require('../../assets/images/home-prize-4.png'), require('../../assets/images/home-prize-5.png')],
      tempArray1: [require('../../assets/images/home-prize-6.png'), require('../../assets/images/home-prize-7.png')],
      imageArray: [],
      level: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖'],
      formInline: {},
      publicOptions: [],
      styles: cityOptions,
      tableData: [],
      prizeOptions: [
        {
          value: 1,
          label: '实物'
        },
        {
          value: 2,
          label: '红包'
        },
        {
          value: 3,
          label: '优惠券'
        },
        {
          value: 4,
          label: '积分'
        }
      ],
      everydayNumMax: 1,
      lotteryNumMax: 1,
      activityId: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      }
    }
  },
  methods: {
    getPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.publicOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
        this.getData()
      })
    },
    // 获取客户来源
    getSourceList() {
      getCustomerSourceListForWepage(1).then((res) => {
        if (res.data.code === 0) {
          this.sources = res.data.data.list
        }
      })
    },
    getData() {
      this.activityId = this.$route.query.id
      getActivityDetails(this.activityId).then(res => {
        this.formInline = res.data.data
        this.tagsArray = res.data.data.tags
        this.date = [this.formInline.start_time, this.formInline.end_time]
        if (this.formInline.page_style === 1) {
          this.imageArray = this.tempArray
        } else {
          this.imageArray = this.tempArray1
        }
      })
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getPublicList()
    this.getSourceList()
  }
}
</script>

<style scoped>
  .create-acivity {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    width: calc(100% - 40px);
    background: #fff;
    margin: 20px auto 0;
    overflow-x: hidden;
  }
  .acivity-left {
    width: 43%;
    height: 800px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    position: relative;
  }
  .acivity-right {
    width: 57%;
    height: 800px;
    align-items: center;
    display: flex;
    justify-content: flex-start;
  }
  .mobile-img {
    position: absolute;
  }
  .scrol-image {
    /*margin-left: 130px;*/
  }
  .liuhai{
    position: absolute;
    top: 113px;
    z-index: 100;
  }
  .scrol-image, .scrol-image .el-carousel__item  {
    height: 575px;
    width: 266px;
    border-radius: 26px;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .tab-tit {
    width: 394px;
    margin: 90px auto 0;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .tab-tit .cur {
    background: #1890FF;
    color: #fff;
  }

  .tab-tit .line, .saveData .line{
    width:90%;
    margin: 2% auto;
    border:0.5px dashed #d2d2d2;
  }
  .tab-tit a {
    cursor: pointer;
    display:block;
    float: left;
    width: 130px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    text-align: center;
    background: #fff;
    color: #333;
    border:1px solid #1890FF;
  }
  .acivity-content-form {
    width: 394px;
    text-align: center;
    margin: auto;
  }
  .acivity-setting-form {
    width: 394px;
    text-align: center;
    margin: auto;
  }
  .acivity-prize-form {
    /*text-align: center;*/
    /*margin: 0 auto;*/
    width: 100%;
  }
  .acivity-content-form .el-form-item__content {
    width: 300px;
  }
  .acivity-content-form p {
    margin: 0px;
    line-height: 20px;
    text-align: left;
    color: #999;
    font-size: 12px;
  }
  .prize-percent {
    width: 80px;
  }
  .prize-percent .el-input {
    width: 60px;
  }
  .prize-percent .el-input__inner {
    width: 60px;
    height: 36px;
  }
  .home-pic {
    width: 100%;
    height: 100%;
  }
  .avatar-pic {
    height:110px;
    width: 260px;
    display: block;
  }
  .button-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-top: 20px;
  }
  .new-add-setting {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .new-add-table {
    width: 100%;
    margin-top: 40px;
  }
  @media screen and (min-width: 1600px) {
    .acivity-left {
      width: 35%;
      justify-content: flex-end;
      margin-right: 100px;
    }
    .mobile-img{
      right: -23px;
    }
    .liuhai{
      right: 60px;
    }
  }
  .activity-title {
    color: #c0c4cc;
    padding-left: 10px;
    padding-right: 10px;
  }
  .tags-look {
    width: 280px;
  }
</style>
